import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FellowshipForm from "@/components/FellowshipForm";
import Dashboard from "@/components/Dashboard";
import OfflinePage from "@/components/OfflinePage";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoutes from "@/utils/ProtectedRoutes";

function App() {
  const submissionsDisabled = process.env.REACT_APP_DISABLE_SUBMISSIONS === "true";

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={submissionsDisabled ? <OfflinePage /> : <FellowshipForm />} />
        <Route element={<ProtectedRoutes />}>
          <Route path="/dashboard" element={<Dashboard />} />
        </Route>
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;